import { Link } from 'react-router-dom';

interface CourseItem {
  id: string;
  title: string;
  instructor: string;
  instructorCompany: string;
  purchaseDate: string;
  progress: number;
  totalLessons: number;
  completedLessons: number;
  duration: string;
  level: string;
  lastWatched: string | null;
  certificate: boolean;
}

const MyCourses = ({ courses }: { courses: CourseItem[] }) => {
  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <p className="text-sm text-slate-500">
          共 <span className="font-bold text-[#0A1628]">{courses.length}</span> 門已購課程
        </p>
        <Link to="/courses" className="text-xs text-violet-600 hover:text-violet-700 font-semibold cursor-pointer transition-colors">
          瀏覽更多課程
        </Link>
      </div>

      <div className="flex flex-col gap-4">
        {courses.map((course) => (
          <div key={course.id} className="bg-white rounded-2xl border border-slate-100 p-5">
            <div className="flex items-start justify-between gap-3 mb-2">
              <div>
                <h3 className="text-sm font-bold text-[#0A1628] leading-snug">{course.title}</h3>
                <p className="text-xs text-slate-400 mt-1">
                  {course.instructor} · {course.instructorCompany} · {course.duration}
                </p>
              </div>
              <span className="text-[11px] font-semibold px-2 py-0.5 rounded-full bg-violet-50 text-violet-600">
                {course.level}
              </span>
            </div>

            <div className="mb-2">
              <div className="flex items-center justify-between mb-1.5">
                <span className="text-[11px] text-slate-500">
                  已學習 {course.completedLessons} / {course.totalLessons} 課
                </span>
                <span className="text-[11px] font-bold text-violet-600">{course.progress}%</span>
              </div>
              <div className="h-1.5 bg-slate-100 rounded-full overflow-hidden">
                <div className="h-full bg-violet-500 rounded-full" style={{ width: `${course.progress}%` }} />
              </div>
            </div>

            <div className="flex items-center justify-between text-[11px] text-slate-400">
              <span>購買於 {course.purchaseDate || '待同步'}</span>
              <span>{course.lastWatched || (course.certificate ? '已完成課程' : '尚未開始學習')}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyCourses;
